export default {
  namespaced: true,
  state: {
    contexto: {
      ['Recusa Automática']: 'btn-recusa-automatica',
      ['Simulado']: 'btn-simulado',
      ['Simulado Stepper']: 'btn-simulado',
      ['Pendente CNH']: 'btn-pendente-cnh',
      ['Pendente Docs']: 'btn-pendente-docs',
      ['Docs Enviados']: 'btn-docs-enviado',
      ['Em Análise Sicredi']: 'btn-em-analise-sicred',
      ['Docs Validados']: 'btn-docs-validados',
      ['Devolução Ajuste']: 'btn-devolucao-ajustes',
      ['Reanálise Sicredi']: 'btn-reanalise-sicred',
      ['Recusada']: 'btn-recusada',
      ['Aprovada']: 'btn-aprovada',
      ['Operação Liberada']: 'btn-operacao-liberada',
      ['Pend. Autor. de Faturamento']: 'btn-devolucao-ajustes',
      ['Veículo Fora do Perfil']: 'btn-veiculo-fora-perfil',
      ['Vencida']: 'btn-vencida',
      ['Pendente Ass. Contrato']: 'btn-pendente-ass-contrato',
      ['Solicite Pagamento']: 'btn-solicite-pagamento',
    },
    situacoesProposta: [
      { situacao: 'recusa_automatica', nome: 'Recusa Automática' },
      { situacao: 'simulado', nome: 'Simulado' },
      // { situacao: 'simulado_stepper', nome: 'Simulado Stepper' },
      { situacao: 'pendente_cnh', nome: 'Pendente CNH' },
      { situacao: 'pendente_docs', nome: 'Pendente Docs' },
      { situacao: 'docs_enviados', nome: 'Docs Enviados' },
      { situacao: 'em_analise_sicredi', nome: 'Em Análise Sicredi' },
      { situacao: 'docs_validados', nome: 'Docs Validados' },
      { situacao: 'devolucao_ajuste', nome: 'Devolução Ajuste' },
      { situacao: 'reanalise_sicredi', nome: 'Reanálise Sicredi' },
      { situacao: 'recusada', nome: 'Recusada' },
      { situacao: 'aprovada', nome: 'Aprovada' },
      { situacao: 'operacao_liberada', nome: 'Operação Liberada' },
      {
        situacao: 'pendente_autorizacao_faturamento',
        nome: 'Pend. Autor. de Faturamento',
      },
      {
        situacao: 'veiculo_perfil_invalido',
        nome: 'Veículo Fora do Perfil',
      },
      { situacao: 'vencida', nome: 'Vencida' },
      { situacao: 'pendente_ass_contrato', nome: 'Pendente Ass. Contrato' },
      { situacao: 'pendente_solicitar_pagamento', nome: 'Solicite Pagamento' },
    ],
  },
};
